import React from 'react';
import "./ProductMerged.css"


function ProductMerged({title,image1,image2,image3,image4,image5,image6,image7,image8}) {
  return <div className='productmerged'>
      <div className="title">
        <h3>{title}</h3>
      </div>
      
      <div className='images'>
      <img src={image1} alt="" className="image" />
      <img src={image2} alt="" className="image" />
      <img src={image3} alt="" className="image" />
      <img src={image4} alt="" className="image" />
      <img src={image5} alt="" className="image" />
      <img src={image6} alt="" className="image" />
      <img src={image7} alt="" className="image" />
      <img src={image8} alt="" className="image" />       
      </div>

  </div>;
}

export default ProductMerged;
